import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { Box, Button, createTheme, IconButton, MenuItem, Stack } from '@mui/material';
import React, { memo, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { AppState, useAppSelector } from 'src/store';
import StyledMenu from 'src/theme/StyledTheme';
import DocManagementService from '../documentUpload/service/DocManagementService';
import './searchComponentStyles.scss';

const presetObject = (data: any) => {
  const res: any = {};

  for (let i = 0; i <= data.length - 1; i++) {
    res[data[i].name] = data[i].value;
  }
  return res;
};
const SearchPreset = (props: any) => {
  const { setPresetSearchData, isSave, presetName, isClear, handleClear, isPresetValue, metaData, setShowResult } =
    props;
  const docService = new DocManagementService();
  const [anchorElPresetFilterBtn, setAnchorElPresetFilterBtn] = useState<null | HTMLElement>(null);
  const [presetData, setPresetData] = useState<any>([]);
  const [selectedPresetText, setSelectedPresetText] = useState('Filter Preset');
  const openPresetFilterBtn = Boolean(anchorElPresetFilterBtn);
  const isfLevel = 'Site';
  const selectedStudy = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Study);
  const selectedCountry = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Country);
  const selectedSite = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Site);

  const handleClickPresetFilterBtn = async (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElPresetFilterBtn(event.currentTarget);
    setPresetSearchData({
      isEdit: false,
      isPreset: isPresetValue,
      preset_name: selectedPresetText,
      presetObject: metaData
    });
  };
  const handleClosePresetFilterBtn = () => {
    setAnchorElPresetFilterBtn(null);
  };

  const handleOpenDeletePreset = (el: any) => {
    el.isDeletePreset = true;
    el.isEdit = false;
    setPresetSearchData(el);
  };

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  useEffect(() => {
    getAllFilterPresets();
  }, [isSave, isClear]);

  const getAllFilterPresets = async () => {
    const res: any = await docService.getAllFilterPresets(
      selectedStudy,
      selectedCountry,
      selectedSite,
      isfLevel,
      process.env.REACT_APP_NAME,
      'Search'
    );
    if (res.data) {
      setPresetData(res.data);
      if (isClear) {
        setSelectedPresetText('Filter Preset');
      } else {
        setSelectedPresetText(presetName === '' ? selectedPresetText : 'Filter Preset');
      }
    } else {
      if (res.error?.response?.status !== 404) {
        setPresetData([]);
        setSelectedPresetText('Filter Preset');
      }
    }
  };

  const handleClickOpenEditPreset = (el: any, isEdit: boolean) => {
    el.presetFilter = null;
    el.isEdit = isEdit;
    el.isPreset = true;
    el.isDeletePreset = false;
    el.presetObject = presetObject(el.preset_conditions.filter);
    setPresetSearchData(el);
    setAnchorElPresetFilterBtn(null);
  };

  const handlePresetClick = async (el: any, isPreset: boolean) => {
    el.presetFilter = el.preset_conditions.filter;
    el.isPreset = isPreset;
    el.presetObject = presetObject(el.presetFilter);
    setPresetSearchData(el);
    setAnchorElPresetFilterBtn(null);
    setSelectedPresetText(el.preset_name);
    el.isDeletePreset = false;
  };

  const doReset = (e: any) => {
    e.stopPropagation();
    handleClear();
    setShowResult(false);
    setPresetSearchData({ isEdit: false, isPreset: false });
    setSelectedPresetText('Filter Preset');
  };

  const theme = createTheme({
    breakpoints: {
      values: {
        xs: 300, // phone
        sm: 600, // tablets
        md: 900, // small laptop
        lg: 1200, // desktop
        xl: 1600 // large screens
      }
    }
  });

  const ITEM_HEIGHT = 48;

  return (
    <>
      <Button
        className="filterPreset-btn"
        sx={{ flex: 1 }}
        endIcon={<ArrowDropDownIcon />}
        id="demo-customized-button"
        aria-controls={open ? 'demo-customized-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        variant="text"
        disableElevation
        disableRipple
        onClick={handleClickPresetFilterBtn}
        tabIndex={3}
      >
        {selectedPresetText}
        {selectedPresetText !== 'Filter Preset' && (
          <IconButton aria-label="delete" size="small" className="closeBtnFP" onClick={e => doReset(e)}>
            <CloseIcon fontSize="small" />
          </IconButton>
        )}
      </Button>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          'aria-labelledby': 'demo-customized-button'
        }}
        anchorEl={anchorElPresetFilterBtn}
        open={openPresetFilterBtn}
        onClose={handleClosePresetFilterBtn}
        className="filterPresetDropdown"
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 7
          }
        }}
        disableScrollLock={true}
      >
        {presetData &&
          presetData.map((el: any, i: number) => (
            <MenuItem
              key={i}
              value={el.preset_name}
              sx={{
                minWidth: {
                  lg: 170,
                  xl: 324
                },
                maxWidth: {
                  lg: 220,
                  xl: 360
                }
              }}
            >
              <Box className="FilterPresetMenuItem">
                <Box className="FPName" onClick={() => handlePresetClick(el, true)}>
                  {el.preset_name}
                </Box>
                <Box>
                  <Stack direction="row" alignItems="center" spacing={0.5}>
                    <IconButton aria-label="edit" size="small">
                      <EditIcon fontSize="small" onClick={() => handleClickOpenEditPreset(el, true)} />
                    </IconButton>
                    <IconButton aria-label="delete" size="small">
                      <DeleteIcon fontSize="small" onClick={() => handleOpenDeletePreset(el)} />
                    </IconButton>
                  </Stack>
                </Box>
              </Box>
            </MenuItem>
          ))}
      </StyledMenu>
    </>
  );
};

export default memo(SearchPreset);
